import{observer,ComponentView,Preact,h,state,action,Router,Link,Cls,m,Keyframes,getParentUidEl,Media} from "@websites/website_compiler/Client";
import {AEComponentView,Ui} from "../../stores/ui";
import * as C from "../../components/BaseCss";
import * as Icons from "../../components/Icons";
import * as Sidepanel from "../../components/Sidepanel";
import {Footer, VerticalSpacer, PageMargins,SolidBtn,PageTitle, SquareGrid,HeaderLeft,HeaderCenter,HeaderRight,Header,App} from "../../components/Misc";
import * as Css from "./galleryCss";

const images = ["img_1","img_2","img_3","img_4","img_5","img_6","img_7","img_8","img_9","img_10","img_11","img_12"];
function getImgUrl(name:string,width:number,srcset?:boolean){
    return `/assets/gallery/${name}_${width}w.jpg ${srcset ? width + "w" : ""}`;
}
export module Slider{
    export class Props{
        onIndexChange:Function;
        index:number;
        ui:Ui;
    }
    @observer
    export class View extends AEComponentView<Props>{
        @state width = 500;
        @state containerWidth;
        @state transClass= Css.sliderImageTrans;
        imageTransRef = Preact.createRef();
        containerRef = Preact.createRef();
        @state xOffset = 0;
        @state isSwiping = false;
        @state hasResize = false;
        // @state index = 0;

        constructor(props:Props){
            super(props);
            
            this.computeWidth();
   
        }
        componentDidMount(){
            window.addEventListener("resize",this.onResize);
        }
        componentWillUnmount(){
            window.removeEventListener("resize",this.onResize);
        }

        @action computeWidth(){
            if (typeof window !== 'undefined') {
                this.width = window.innerWidth
            }
        }
        setIndex(index){
            this.props.onIndexChange(index);
        }
        @action setAnimClass(setAnim = false){
            if(setAnim){
                var className = m(Css.sliderImageTrans,Css.sliderImageTransAnim);

            }else{
                var className = m(Css.sliderImageTrans);

            }

            this.imageTransRef.current.className = className;
            this.transClass = className;
        }

        onResize = (event) =>{
            
            this.setAnimClass(false)
            this.computeWidth();
        }


        onMouseDown = (event) =>{
            event.preventDefault();
            event.stopPropagation()
            this.ui.pointer.setDown(event);
            this.onDown();
        }
        onMouseMove = (event) =>{
            event.preventDefault();
            event.stopPropagation()
            this.ui.pointer.setMove(event);
            this.onMove(this.ui.pointer.isDown,this.ui.pointer.getMouseMoveTravelDistanceX());
            
        }
        onMouseUp = (event) =>{
            console.log("UP",event);
            
            event.preventDefault();
            event.stopPropagation()
            this.ui.pointer.setUp(event);
            this.onUp(this.ui.pointer.getMouseMoveTravelDistanceX());
        }

        @action onTouchStart= (event) =>{
            event.preventDefault();
            this.ui.pointer.setTouchStart(event);
            this.onDown();
        }
        @action onTouchMove = (event) =>{
            event.preventDefault();
            this.ui.pointer.setTouchMove(event);
            this.onMove(this.ui.pointer.isDown,this.ui.pointer.getTouchTravelDistanceX()); 
        }
        @action  onTouchUp = (event) =>{
            event.preventDefault();
            this.ui.pointer.setTouchUp(event);
            this.onUp(this.xOffset)
        }

        @action onDown(){
            console.log("downn",);
            
            this.xOffset = 0;
            this.computeWidth();
            this.setAnimClass(false);

        }
        @action onMove(isDown,xDistance){

            if(isDown){
                if(!this.isSwiping){
                    this.isSwiping = true;  
                      
                }

                this.xOffset = xDistance;

            }

        }
        @action onUp(xTravelDistance :number){
            this.setAnimClass(true)
            this.isSwiping = false;    
            this.xOffset = 0;

            if(xTravelDistance  > 50){
                this.setIndex(Math.max(0,this.props.index  - 1))
            }else if(xTravelDistance < -50){
                this.setIndex(Math.min(this.props.index + 1,images.length))
            }


        }

        onClick = (event) =>{
            event.preventDefault();
            event.stopPropagation()
        }

        render(){
            var width :number = this.width;

            var indexTrans = (this.props.index * width) * -1;
            
            if(this.isSwiping){
                var imageTrans = indexTrans + this.xOffset;
                var left = imageTrans + "px";
            }else{
                var left = indexTrans  + "px";
            }

            
            return(
                <div ref={this.containerRef} onTouchEnd={this.onTouchUp}  onTouchStart={this.onTouchStart}  onTouchMove={this.onTouchMove} onMouseDown={ this.onMouseDown}    onMouseMove={ this.onMouseMove} onMouseUp={this.onMouseUp} class={m(Css.sliderContainer)}>
                    <div ref={ this.imageTransRef} class={this.transClass} style={{left:left}}>
                        {
                            images.map((photo,i)=>{                                
                                if(i > (this.props.index  + 2)){                                    
                                    return;
                                }

                                return <div >
                                    <div class={Css.sliderImageContainer}>
                                        <img  class={Css.sliderImageFullMode} src={getImgUrl(photo,1280)}></img>
                                    </div>
                                </div>
                            })
                        }
                    </div>
                </div> 
            )
        }                                                         
    }
 


}
export module FullView{
    export class Props{
        onBack:Function;
        index:number;
        ui:Ui;
    }
    
    export class View extends AEComponentView<Props>{
        @state index = 0;

        constructor(props:Props){
            super(props);
            this.index = props.index;
        }
        @action setGaleryIndex = (index) =>{
            this.index = Math.min(Math.max(0,index),images.length - 1); // need extra for profile image
            console.log("setGaleryIndex",this.index);
            
        }
        @action leftBtnClick = () =>{
            this.setGaleryIndex(this.index - 1);
             
        }
        @action rightBtnClick = () =>{
            this.setGaleryIndex(this.index + 1);
        }

        render(){

            return (

                <Preact.Fragment>
                    <div class={Css.fvHead}>
                        <HeaderLeft>
                            <button class={Css.fvBackBtn} onClick={this.props.onBack}>
                                <Icons.Arrow_Left class={C.icon20px}></Icons.Arrow_Left>
                            </button>
                        </HeaderLeft>
                        <HeaderCenter>
                            <Icons.Logo_Icon class={C.icon30px}></Icons.Logo_Icon>
                            <div class={Css.fvTitle}>Gallery</div>
                        </HeaderCenter>
                        <HeaderRight>
                            <div class={Css.fvRight}>
                                {(this.index + 1) + " / " + images.length}
                            </div>
                        </HeaderRight>
                        </div>

                        <div class={Css.fvBody}>
    
                            <div class={Css.fvImageContainer}>
                                <Slider.View index={this.index} onIndexChange={this.setGaleryIndex} ui={this.ui}></Slider.View>
                            </div>
                            <div class={m(Css.fvSides,Css.fvSidesLeft)}>
                                <button  style={{opacity:this.index == 0 ? 0.5 : 1} } onClick={this.leftBtnClick} class={Css.fvArrowBtn} ><Icons.Arrow_Left class={Css.fvArrow}></Icons.Arrow_Left></button>
                            </div>
                            <div class={m(Css.fvSides,Css.fvSidesRight)}>
                                <button  style={{opacity:this.index == (images.length - 1) ? 0.5 : 1} } onClick={this.rightBtnClick} class={Css.fvArrowBtn} ><Icons.Arrow_Right class={Css.fvArrow}></Icons.Arrow_Right></button>

                            </div>

                        </div>
                </Preact.Fragment>

            )
        }
        
    }
    

}
export function Square(props:{name:string}){
    return <div >
        <div class={Css.pageSquareBtn} data-uid={props.name}>
            <img src={getImgUrl(props.name,256)} class={Css.pageSquareImg}></img>
        </div>
    </div>
}

export class Props{}
@observer export class Page extends AEComponentView<Props>{
    @state fullMode = false;
    @state index = 0;
    addAnimation = true;
    constructor(props:Props){
        super(props);
        if(this.props.matches.index){
            this.index = parseInt(this.props.matches.index);
            this.fullMode = true;
        }
    }
    componentDidMount(){
        if(this.addAnimation){
            setTimeout(() =>{
                this.addAnimation = false;

            },1000);
        }
    }
    @action onClick = (event) =>{
        var el = getParentUidEl(event.target);
        console.log("onClick",el);

        if(!el){return;}
        
        var index = images.indexOf(el.dataset.uid);
        console.log("index",index);
        
        this.index = index;
        this.fullMode = true;
    }
    @action onBack = (event) =>{
        this.fullMode = false;

    }
    render(){

        return (
            
            <App  ui={this.ui} description={"Aquatic Edge Gallery | A few snaps of our work!"}>
                {this.fullMode && <FullView.View index={this.index} onBack={this.onBack} ui={this.ui}></FullView.View>}

                <div style={{display:this.fullMode ? "none" : "block"}}>
                    <Header ui={this.ui}>
                        <HeaderLeft ui={this.ui}></HeaderLeft>
                        <HeaderCenter></HeaderCenter>
                        <HeaderRight></HeaderRight>
                    </Header>
                    <PageMargins  small innerCls={Css.pageBodyContainer}>
                        <PageTitle title="Gallery" subTitle="Here are a few snaps of our work!" addAnimation={this.addAnimation}></PageTitle>

                        <div class={m(Css.pageContentContainer, this.addAnimation ? Css.pageContentContainerAnimation : null)} onClick={this.onClick}>
                            <SquareGrid.View>
                                {
                                    images.map((img,i)=>{
                                        return <Square name={img}></Square>

                                    })
                                }
                        
                            </SquareGrid.View>
                        </div>

                    </PageMargins>
                    <VerticalSpacer></VerticalSpacer>
                    <Footer.View></Footer.View>
                    <Sidepanel.View  ui={this.ui}></Sidepanel.View>
                </div>

            </App>

        )
    }
    
}